import { render, staticRenderFns } from "./InstitutionsView.vue?vue&type=template&id=92863384&scoped=true"
import script from "./InstitutionsView.vue?vue&type=script&lang=js"
export * from "./InstitutionsView.vue?vue&type=script&lang=js"
import style0 from "./InstitutionsView.vue?vue&type=style&index=0&id=92863384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92863384",
  null
  
)

export default component.exports